import { Button } from '@packages/shared/src/ui/Button/Button';

export type ImageGalleryCallToActionButtonProps = {
  buttonAriaLabel: string;
  children: React.ReactNode;
  onClick: () => void;
};

/**
 * <p>
 * This component is used as Wrapper for the ImageGalleryCallToActionButton.
 * </p>
 */

export const ImageGalleryCallToActionButton = ({
  buttonAriaLabel,
  children,
  onClick,
}: ImageGalleryCallToActionButtonProps) => (
  <Button
    onClick={onClick}
    className="bg-color-text-light h-[40px] w-[40px] touch-manipulation rounded-xl border-none shadow-md"
    aria-label={buttonAriaLabel}
  >
    {children}
  </Button>
);
